import { render, staticRenderFns } from "./LabelSetForm.vue?vue&type=template&id=79ec395f&"
import script from "./LabelSetForm.vue?vue&type=script&lang=js&"
export * from "./LabelSetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports